/* eslint-disable jsx-a11y/label-has-associated-control,jsx-a11y/label-has-for */
import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { Button } from '@progress/kendo-react-buttons'
import { Window } from '@progress/kendo-react-dialogs'
import { Upload } from '@progress/kendo-react-upload'
import { TabStrip, TabStripTab } from '@progress/kendo-react-layout'
import { EditorUtils } from '@progress/kendo-react-editor'
import { withTranslation } from 'react-i18next'
import i18n from 'i18n'
import { InsertImageFiles } from './utils'

export const InsertImageDialog = props => {
  const [selected, setSelected] = React.useState(0)
  const [files, setFiles] = React.useState([])
  let src
  let altText
  let title
  let width
  let height

  const onTabSelect = event => {
    setFiles([])
    setSelected(event.selected)
  }

  const onClose = () => {
    props.onClose.call(undefined)
  }

  const onAddFiles = event => {
    setFiles(event.newState.map(f => f.getRawFile && f.getRawFile()).filter(f => f))
  }

  const onInsert = () => {
    const { view, imageNode } = props
    const { nodes } = view.state.schema
    const nodeType = nodes[imageNode]
    const position = null
    const data = {
      src: src ? src.value : null,
      title: title ? title.value : null,
      alt: altText ? altText.value : null,
      width: width ? width.value : null,
      height: height ? height.value : null,
    }
    const attrs = Object.keys(data)
      .filter(key => data[key] !== null && data[key] !== '')
      .reduce(
        (acc, curr) =>
          Object.assign(acc, {
            [curr]: data[curr],
          }),
        {},
      )

    if (files.length) {
      InsertImageFiles({
        view,
        files,
        nodeType,
        position,
        attrs,
      })
    } else {
      const newImage = nodeType.createAndFill(attrs)
      EditorUtils.insertNode(view, newImage, true)
    }
    view.focus()
    onClose()
  }

  const { view, imageNode } = props
  const state = view && view.state
  let attrsDet = {}

  if (
    state &&
    state.selection.node &&
    state.selection.node.type === state.schema.nodes[imageNode]
  ) {
    const { attrs } = state.selection.node
    attrsDet = attrs
  }

  const fields = (
    <React.Fragment>
      <div className="k-edit-label">
        <label htmlFor="k-editor-image-alt">{i18n.t('Alternate text')}</label>
      </div>
      <div className="k-edit-field">
        <input
          type="text"
          className="k-textbox"
          id="k-editor-image-alt"
          defaultValue={attrsDet.alt}
          ref={e => {
            altText = e
          }}
        />
      </div>
      <div className="k-edit-label" hidden="true">
        <label htmlFor="k-editor-image-title">{i18n.t('Title')}</label>
      </div>
      <div className="k-edit-field" hidden="true">
        <input
          type="text"
          className="k-textbox"
          id="k-editor-image-title"
          defaultValue={attrsDet.title}
          ref={e => {
            title = e
          }}
        />
      </div>
      <div className="k-edit-label" hidden="true">
        <label htmlFor="k-editor-image-width">{i18n.t('Width (px)')}</label>
      </div>
      <div className="k-edit-field" hidden="true">
        <input
          type="text"
          className="k-textbox"
          id="k-editor-image-width"
          defaultValue={attrsDet.width}
          ref={e => {
            width = e
          }}
        />
      </div>
      <div className="k-edit-label" hidden="true">
        <label htmlFor="k-editor-image-height">{i18n.t('Height (px)')}</label>
      </div>
      <div className="k-edit-field" hidden="true">
        <input
          type="text"
          className="k-textbox"
          id="k-editor-image-height"
          defaultValue={attrsDet.height}
          ref={e => {
            height = e
          }}
        />
      </div>
    </React.Fragment>
  )

  const buttons = (
    <>
      <div className="text-right" style={{ clear: 'both' }}>
        <Button className="mb-2 mr-2 cm-btn-primary" primary="true" onClick={onClose}>
          {i18n.t('Cancel')}
        </Button>
        <Button className="mb-2 cm-btn-primary" onClick={onInsert} primary="true">
          {i18n.t('Insert')}
        </Button>
      </div>
    </>
  )

  return ReactDOM.createPortal(
    <Window title={i18n.t('Insert Image')} onClose={onClose} initialWidth={500} initialHeight={350}>
      <TabStrip selected={selected} onSelect={onTabSelect} animation={false}>
        {Object.entries(attrsDet).length === 0 && (
          <TabStripTab title={i18n.t('Upload')}>
            <div className="k-edit-form-container pt-3 pb-3">
              <div className="k-edit-label">
                <label htmlFor="k-editor-image-width">{i18n.t('Image')}</label>
              </div>
              <div className="k-edit-field">
                <Upload
                  batch="false"
                  multiple="true"
                  defaultFiles={[]}
                  withCredentials="false"
                  saveUrl=""
                  removeUrl=""
                  onAdd={onAddFiles}
                />
              </div>
              {fields}
              {buttons}
            </div>
          </TabStripTab>
        )}
        <TabStripTab title={i18n.t('By URL')}>
          <div className="k-edit-form-container pt-3 pb-3">
            <div className="k-edit-label">
              <label htmlFor="k-editor-image-url">{i18n.t('Web address')}</label>
            </div>
            <div className="k-edit-field">
              <input
                type="text"
                className="k-textbox"
                id="k-editor-image-url"
                defaultValue={attrsDet.src}
                disabled={/^data:image/.test(attrsDet.src || '')}
                ref={e => {
                  src = e
                }}
              />
            </div>
            {fields}
            {buttons}
          </div>
        </TabStripTab>
      </TabStrip>
      <style>{`.k-dropzone { width: 100%; }`}</style>
    </Window>,
    document.body,
  )
}
export default withTranslation()(InsertImageDialog)
